import { Typography } from "@mui/material";
import { FeeConfigActionsPopover } from "./fee-config-actions-popover";

export const getProductFeeColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div>ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id ?? "—"}</Typography>
    ),
  },
  {
    accessorKey: "category",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.category?.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "categoryCode",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.category?.code ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "product",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Chargeable Product</div>
    ),
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.product?.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "productCode",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Product Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.product?.code ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "percentage",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Percentage</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.percentage != null ? `${row.original.percentage}%` : "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "capAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Local Fee Cap</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.capAmount ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdBy ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created At</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdAt
          ? new Date(row.original.createdAt).toLocaleString()
          : "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => <div>Action</div>,
    cell: ({ row }) => (
      <FeeConfigActionsPopover
        categoryFee={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];
